// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_z-7";
export var adjustableWidthBorderHeld = "_z-8";
export var arrow = "_z-3";
export var arrowButton = "_z-4";
export var headerCell = "_z-0";
export var help = "_z-2";
export var icon = "_z-1";
export var iconWrapper = "_z-6";
export var noBorder = "_z-b";
export var nonAdjustableWidthBorder = "_z-9";
export var nonAdjustableWidthBorderHeld = "_z-a";
export var textButton = "_z-5";